import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";
import {  ParamsEnviosCanalComercializacion } from 'app/models/requireme';

const controller = rpcController("EnviosCanalComercializacion");

/**Resource del reporte de estadísticas de clientes*/
export const RepEnviosCanalComercializacion = cacheResource({
Generar: async (
parametros: ParamsEnviosCanalComercializacion): Promise<string> =>
await controller("GenerarReporteEnviosCanalComercializacion", {}, parametros)
}, {
}, {
})


// WEBPACK FOOTER //
// ./app/resources/items/envioscanalcomercializacion.tsx